import { Button, DropdownToggle } from 'reactstrap';
import styled from 'styled-components';
import ChevronIcon from '../icons/ChevronIcon';

/**
 * NOTE: the `toggle` prop should only be used when this component is within a Dropdown.
 */
const IconButton = styled(({ toggle, children, ...props }) => {
  const ButtonComponent = toggle ? DropdownToggle : Button;
  return (
    <ButtonComponent {...props}>
      {children}
      {toggle && <ChevronIcon />}
    </ButtonComponent>
  );
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ $inline }) => $inline && 'line-height: 1;'}
  & > svg:last-child {
    margin-left: 0.3em;
    flex-shrink: 0;
  }
`;

export default IconButton;
